export const listConstants = {
    INIT_LIST_CONSTANT: 'INIT_LIST_CONSTANT',
    GET_CAMPAIGN_CATEGORY_LIST:"GET_CATEGORY_LIST_BY_CAMPAIGN"
}
